import React from 'react';
import BillingTransactionDetailSection from '../../../sections/AdminDashboard/Finance/FinancePaymentDetail';

const BillingTransactionDetail = () => {
  return <BillingTransactionDetailSection />;
};

export default BillingTransactionDetail;


